<script lang="ts">
	import { page } from '$app/stores';
	import type { RequiredProduct } from '$lib/types';
	import { mapToNode } from '$lib/utils/product';

	let technicalDetailsHeadersSet = new Set<string>();
	let technicalData: Record<string, string> = {};

	$: if ($page.data?.product?.variants) {
		const variants: RequiredProduct['variants'] = $page.data?.product?.variants;
		const mapped = mapToNode(variants);
		technicalData = {};
		technicalDetailsHeadersSet = new Set<string>();
		for (const variant of mapped) {
			if (variant?.technical_data?.value) {
				technicalData = JSON.parse(variant?.technical_data?.value || '{}');
				technicalDetailsHeadersSet = new Set([
					...Object.keys(technicalData),
					...technicalDetailsHeadersSet
				]);
			}
		}
	}

	$: technicalDetailsHeaders = Array.from(technicalDetailsHeadersSet);
</script>

<div
	class="grid gap-x-3 gap-y-1 mt-12 overflow-x-auto pb-4"
	style:grid-template-columns={`repeat(${technicalDetailsHeaders.length}, max-content)`}
	style:grid-template-rows="1fr min-content"
>
	{#each technicalDetailsHeaders as value}
		<div class="font-bold uppercase">
			{value}
		</div>
	{/each}

	{#each mapToNode($page.data?.product?.variants) as variant}
		{@const technicalData = variant?.technical_data?.value
			? JSON.parse(variant.technical_data.value)
			: {}}
		{#each technicalDetailsHeaders as header}
			<div>
				{technicalData[header]?.includes('§')
					? technicalData[header].split('§').shift()
					: technicalData[header] ?? null}
			</div>
		{/each}
	{/each}
</div>
